import React, { useContext, useState, useEffect } from "react";
import { MediaQueriesContext, AuthContext } from "@/App.jsx";
import { useHistory, useLocation } from "react-router-dom";
import { alertSuccess } from "Utils/alerts";

import _ from "lodash";
import PaginationFilter from "Components/paginationFilter/PaginationFilter";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import cx from "classnames";

import ConfirmModal from "Components/confirmModal/ConfirmModal";
import { refresh } from "Icons/index";
import ResponsiveTable from "Components/responsiveTable/ResponsiveTable";
import t from "Utils/translation";
import useQueryParams from "Utils/useQueryParams";
import usePaginatedList from "../utils/usePaginatedList";
import QboxmailApi from "../qboxmailApi";
import useFormState from "Utils/useFormState";

const api = new QboxmailApi({ useCookie: true });

const MXListScreens = function () {
  const history = useHistory();
  const media = useContext(MediaQueriesContext);
  const auth = useContext(AuthContext);
  const location = useLocation();
  const searchParams = useQueryParams();
  const { data, isRefreshing, refreshList, isFiltering } = usePaginatedList(`/system/mx?${searchParams}`);
  const [recordToDelete, setRecordToDelete] = useState(null);
  const [newModalOpened, setNewModalOpened] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [alreadyExists, setAlreadyExists] = useState(false);

  const {
    setFormFieldValue,
    formErrors,
    resetForm,
    formData,
    setFormLoading,
    unsetFormLoading,
    isFormLoading,
    setFormErrors,
  } = useFormState();

  const destroy = async () => {
    setIsSubmitting(true);
    await api.deleteMXRecord(recordToDelete);
    await refreshList();
    setIsSubmitting(false);

    setRecordToDelete(null);
    alertSuccess(t("alert.mxDeletedSuccess"));
  };

  const submit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await api.addMXRecord(formData);
    } catch (err) {
      setIsSubmitting(false);

      if (err.status === 422) {
        setAlreadyExists(true);
        return true;
      } else {
        return false;
      }
    }

    await refreshList();
    setNewModalOpened(false);

    alertSuccess(t("alert.mxCreatedSuccess"));
  };

  useEffect(() => {
    if (!newModalOpened) {
      setIsSubmitting(false);
      setAlreadyExists(false);
      resetForm();
    }
  }, [newModalOpened]);

  const openEdit = (id) => {
    data?.resources.forEach((r) => {
      if (r.id === id) {
        setFormFieldValue({
          mx1: r.mx1,
          mx2: r.mx2,
          customer_code: r.customer_code,
        });

        setNewModalOpened(true);

        console.log("found", r);
      }
    });
  };

  return (
    <div className="screenContainer">
      <div className="flex justify-between mb-10">
        <div>
          <div className="sectionTitle">{t("mxrecords.list.title")}</div>

          {!media.isMediaMobile && <div className="sectionDesc marginRight80">{t("mxrecords.list.desc")}</div>}
        </div>

        {/* <div className="flex">
          <Button icon={plus} onClick={() => setNewModalOpened(true)} onlyIcon={media.isMediaMobile}>
            button.add
          </Button>
        </div> */}
      </div>

      <div className="flex items-center justify-between gap-2 pt-2">
        <PaginationFilter className="max-w-[240px]" url={location.pathname} currentQuery={searchParams.get("query")} />

        <ButtonIcon
          className={cx({ ["isRefreshing"]: isRefreshing })}
          icon={refresh}
          onClick={isRefreshing ? () => { } : refreshList}
        />
      </div>

      <div className="flex flex-col flex-1 pb-20 overflow-y-scroll">
        <div className="mt-4">
          <ResponsiveTable
            history={history}
            areRowsLoading={!data || isRefreshing || isFiltering}
            location={location}
            showAddIcon={false}
            headers={[
              {
                name: t("table.header.mx1"),
                hideOnMobile: false,
              },

              {
                name: t("table.header.mx2"),
                hideOnMobile: false,
              },

              {
                name: t("table.header.customer"),
                key: "customer_name",
                hideOnMobile: true,
              },

              // { size: "3rem", center: true },
            ]}
            rows={_.map(data?.resources, (r) => {
              return (
                <tr key={r.id}>
                  <td>{r.mx1}</td>
                  <td>{r.mx2}</td>

                  <td>{r.customer_fullname || "-"}</td>
                  {/* 
                  <td className="flex items-center gap-1">
                    <ButtonIcon icon={edit} onClick={() => openEdit(r.id)} />
                    <ButtonIcon icon={trash} onClick={() => setRecordToDelete(r.id)} />
                  </td> */}
                </tr>
              );
            })}
          />
        </div>
      </div>

      {/* <Modal
        title={t("modal.mx.title")}
        opened={newModalOpened}
        closeModal={() => setNewModalOpened(false)}
        footerComponent={
          <div className="flex justify-end gap-1 p-4">
            <Button color="text" onClick={() => setNewModalOpened(false)}>
              button.cancel
            </Button>

            <Button onClick={submit} loading={isSubmitting}>
              button.add
            </Button>
          </div>
        }
      >
        <form onSubmit={submit}>
          <div className="p-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="col-span-2 mb-4">
                {newModalOpened && (
                  <CustomerSelect
                    className="inputFull2"
                    label={t("input.label.customer")}
                    initialValue={formData.customer_code}
                    onChange={(e) => setFormFieldValue({ customer_code: e?.value })}
                    errors={formErrors.customer_code}
                  />
                )}

                <div className="text-sm text-[--text-a40] max-w-[120ch] mt-2">{t("modal.mx.customer.desc")}</div>
              </div>

              <Input
                className="w-full"
                name="mx1"
                label={t("input.label.mx1")}
                placeholder={"mx01.example.com"}
                type="text"
                value={formData.mx1}
                errors={formErrors.mx1}
                onChange={setFormFieldValue}
                trim
                required
              />

              <Input
                className="w-full"
                name="mx2"
                label={t("input.label.mx2")}
                placeholder={"mx02.example.com"}
                type="text"
                value={formData.mx2}
                errors={formErrors.mx2}
                onChange={setFormFieldValue}
                trim
                required
              />

              <Input
                className="w-full"
                name="mx2"
                label={t("input.label.mx2")}
                placeholder={"mx02.example.com"}
                type="text"
                value={formData.mx2}
                errors={formErrors.mx2}
                onChange={setFormFieldValue}
                trim
                required
                blockedTextEnd={".test.com"}
              />

              {alreadyExists && (
                <div className="bg-[--red-l35] px-4 py-2 rounded text-[--red] col-span-2">
                  {t("alert.mxAlreadyExists")}
                </div>
              )}
            </div>
          </div>
        </form>
      </Modal> */}

      <ConfirmModal
        title={`${t("modal.mx.delete")}`}
        text={"Sicuro di voler eliminare il record MX?"}
        textButton={`button.delete`}
        opened={Boolean(recordToDelete)}
        action={destroy}
        handleClose={() => setRecordToDelete(null)}
        isLoading={isSubmitting}
      />
    </div>
  );
};

export default MXListScreens;
